import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TopSelling = () => {
    const [formData, setFormData] = useState({
        sub_category: "",
        product_name: "",
        product_image: null,
    });

    const [preview, setPreview] = useState(null);
    const [subcategory, setsubcategory] = useState([]);
    const [topSellingData, setTopSellingData] = useState([]);
    const [error, setError] = useState("");


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(values => ({ ...values, [name]: value }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setFormData(values => ({ ...values, product_image: file }));
        if (file) {
            setPreview(URL.createObjectURL(file));
        }
    };

    const ADD_TOPSELLING_API = 'https://projects.sninfoserv.com/welb-api/home/add-topselling/';


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.sub_category || !formData.product_name || !formData.product_image) {
            alert("All fields required");
            return;
        }

        const data = new FormData();

        data.append("sub_id", formData.sub_category);
        data.append("product_name", formData.product_name);
        data.append("image", formData.product_image);

        try {
            const response = await fetch(ADD_TOPSELLING_API, {
                method: "POST",
                body: data
            });

            const result = await response.json();
            console.log(result);

            if (result.status === "success") {
                alert("Top selling product added");
                setFormData({
                    sub_category: "",
                    product_name: "",
                    product_image: null
                });
                setPreview(null);
                fetchTopSelling();
            } else {
                alert(result.message);
            }

        } catch (error) {
            console.error(error);
            alert("API error");
        }
    };


    const fetchTopSelling = async () => {
        try {
            const response = await axios.get(
                'https://projects.sninfoserv.com/welb-api/home/top-selling/'
            );

            if (response.data.status === "success") {
                setTopSellingData(response.data.data);
            } else {
                console.error(response.data.message);
            }
        } catch (err) {
            console.error(err.message);
            setError(err.message);
        }
    };


    const fetchSubcategories = async () => {
        try {
            const response = await axios.get('https://projects.sninfoserv.com/welb-api/admin/categories/subcategories/');
            console.log(response.data);
            if (response.data.status === "success") {

                setsubcategory(response?.data.data);
            } else {
                console.error(response.data.error?.message);
            }
        } catch (err) {
            setError(err.message);
        }
    };

    useEffect(() => {
        fetchSubcategories();
        fetchTopSelling();
    }, []);


    const DELETE_TOPSELLING_API = 'https://projects.sninfoserv.com/welb-api/home/delete-topselling/';

    const handleDelete = async (id) => {

        const confirmDelete = window.confirm("Are you sure you want to delete this product?");
        if (!confirmDelete) return;

        const formData = new FormData();
        formData.append("id", id);

        try {
            const response = await fetch(DELETE_TOPSELLING_API, {
                method: "POST",
                body: formData
            });

            const result = await response.json();

            if (result.status === "success") {
                alert("Product deleted successfully");
                fetchTopSelling();

            } else {
                alert(result.message);
            }

        } catch (error) {
            console.error(error);
            alert("Delete API error");
        }
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="mb-3">
                                    <h5
                                        className="mb-0 fw-bold d-inline-block px-3 py-2 rounded"
                                        style={{
                                            fontSize: '30px',
                                            background: "linear-gradient(135deg, #0d6efd15, #0d6efd08)",
                                            borderLeft: "5px solid #0d6efd",
                                            color: "#0d6efd",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Add Top Selling Product
                                    </h5>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="form-body">
                                        <div className="row">

                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label>Sub Category</label>
                                                    <select
                                                        className="form-control"
                                                        name="sub_category"
                                                        value={formData.sub_category}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">-- Select Sub Category --</option>

                                                        {subcategory.map((sub) => (
                                                            <option key={sub.sub_id} value={sub.sub_id}>
                                                                {sub.sub_cate}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            {/* Product Name */}
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label>Product Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="product_name"
                                                        placeholder="Enter product name"
                                                        value={formData.product_name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>

                                            {/* Product Image */}
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label>Product Image</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="product_image"
                                                        accept="image/*"
                                                        onChange={handleImageChange}
                                                    />
                                                    {preview && (
                                                        <div className="mt-2">
                                                            <img
                                                                src={preview}
                                                                alt="Preview"
                                                                width="80"
                                                                height="80"
                                                                className="rounded"
                                                                style={{ objectFit: 'cover', border: '1px solid #ddd' }}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="form-actions">
                                        <div className="text-start">
                                            <button type="submit" className="btn btn-light-primary text-primary font-medium mb-5">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                                    <h5 className="mb-0">Top Selling Products</h5>
                                    {/* <div className="dataTables_filter">
                                        <label className="d-flex align-items-center gap-2 my-2">
                                            Search:
                                            <input
                                                type="search"
                                                className="form-control form-control-sm"
                                                placeholder=""
                                            />
                                        </label>
                                    </div> */}
                                </div>

                                <div className="table-responsive" style={{ overflowX: 'auto' }}>
                                    <table className="table border table-striped table-bordered align-middle">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Image</th>
                                                <th>Product Name</th>
                                                <th>Sub Category</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {topSellingData.length === 0 ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        No products found
                                                    </td>
                                                </tr>
                                            ) : (
                                                topSellingData.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>

                                                        <td>
                                                            <img
                                                                src={`https://projects.sninfoserv.com/welb-api/uploads/topselling/${item.image}`}
                                                                width="45"
                                                            />
                                                        </td>

                                                        <td>{item.product_name}</td>

                                                        <td>
                                                            {
                                                                subcategory.find(sub => sub.sub_id === item.sub_id)?.sub_cate || "N/A"
                                                            }
                                                        </td>
                                                        <td>
                                                            <span
                                                                className="badge bg-danger"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => handleDelete(item.id)}
                                                            >
                                                                Remove
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TopSelling;